var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white patent padding-auto"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":18}},[_c('Search')],1),_c('el-col',{attrs:{"span":6}},[_c('Recommend')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }